import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {PaginatorModule} from "primeng/paginator";
import {ReservationService} from "../../../../../../../core/services/reservations/reservation.service";
import {forkJoin, timestamp} from "rxjs";
import {Service} from "../../../../../../../models/Service";
import {Vehicle} from "../../../../../../../models/Vehicle";
import {FormErrorDirective} from "../../../../../../../shared/directives/forms/form-error.directive";
import {FormInputDirective} from "../../../../../../../shared/directives/forms/form-input.directive";
import {FormLabelDirective} from "../../../../../../../shared/directives/forms/form-label.directive";
import {JsonPipe, NgForOf, NgIf} from "@angular/common";
import {LoaderComponent} from "../../../../../../../shared/components/loader/loader.component";
import {Step2Quadrants} from "../../../../../../../models/StationForm/Step2Quadrants";
import {StationFormService} from "../../../../../../../core/services/stations/station-form.service";
import {FuelService} from "../../../../../../../core/services/fuels/fuel.service";
import {Fuel} from "../../../../../../../models/Fuel";
import {VehiclesService} from "../../../../../../../core/services/vehicles/vehicles.service";
import {ServicesService} from "../../../../../../../core/services/services/services.service";
import {NextButtonDirective} from "../../../../../../../shared/directives/buttons/next.directive";
import {FrontBackDirective} from "../../../../../../../shared/directives/buttons/front.back.directive";
import {OutlineButtonDirective} from "../../../../../../../shared/directives/outline/outline-button.directive";
import {Quadrant} from "../../../../../../../models/Quadrant";
import {ToastrService} from "ngx-toastr";
import {OverlayPanelModule} from "primeng/overlaypanel";
import { UserV2 } from '../../../../../../../models/UserV2';
import { UserService } from '../../../../../../../core/services/users/user.service';
import { FormSelectSquareDirective } from '../../../../../../../shared/directives/forms/form-select-square.directive';
import { OperationCanceledException } from 'typescript';

@Component({
  selector: 'app-step2-station',
  standalone: true,
  imports: [
    PaginatorModule,
    ReactiveFormsModule,
    FormErrorDirective,
    FormInputDirective,
    FormLabelDirective,
    NgIf,
    NgForOf,
    LoaderComponent,
    NextButtonDirective,
    FrontBackDirective,
    OutlineButtonDirective,
  FormSelectSquareDirective,
    OverlayPanelModule,
    JsonPipe
  ],
  templateUrl: './step2-station.component.html',
  styleUrl: './step2-station.component.css'
})
export class Step2StationComponent {
  form: FormGroup;
  loading: boolean = false;
  association = false;
  associations : UserV2[] = [];

  services: Service[] = [];
  servicesToAdd: Service[] = [];
  vehicles: Vehicle[] = [];
  vehiclesToAdd: Vehicle[] = [];
  fuels: Fuel[] = [];
  fuelsToAdd: Fuel[] = [];

  @Input() editStation:boolean=false;
  @Output() onAddQuadrants: EventEmitter<Step2Quadrants[]> = new EventEmitter();

  @Input() quadrants:Quadrant[]|undefined = [];

  allFuelSelected:boolean=false;

  toCreateQuadrants: Step2Quadrants[] = [];

  constructor(private fb: FormBuilder,
              private reservationService: ReservationService,
              public stationFormService: StationFormService,
              private fuelService: FuelService,
              private vehiclesService: VehiclesService,
              private serviceService: ServicesService,
              private userService: UserService,
              private toastr:ToastrService) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      services_check: [],
      vehicles_check: [],
      fuels_check: [],
      professional: false,
      association_id:[null],
      type: ['open',[Validators.required]],
      link: [null],
      services: this.fb.array([], [Validators.required, Validators.minLength(1)]),
      vehicles: this.fb.array([], [Validators.required, Validators.minLength(1)]),
      fuels: this.fb.array([], [Validators.required, Validators.minLength(1)]),
    });
    this.loadElements();
    this.refreshStep();
    this.loadAssociations();
  }

  refreshStep(){
    this.stationFormService.stationForm$.subscribe(station => {
      if (station.step2) {
        this.toCreateQuadrants = station.step2.quadrants;
      }
    })
  }

  reset(){
    this.toCreateQuadrants = [];
  }

  loadElements(){
    this.loading = true;
    forkJoin({
      services: this.serviceService.list(),
      vehicles: this.vehiclesService.list(),
      fuels: this.fuelService.list()
    }).subscribe({
      next: (results) => {
        this.services = results.services.data ?? [];
        this.vehicles = results.vehicles.data ?? [];
        this.fuels = results.fuels.data ?? [];

        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        // Manejar errores aquí
        console.error('Error al llamar a los observables:', error);
      }
    });
  }

  loadAssociations(){
    this.userService.listAssociations().subscribe({
      next: (response) => {
        if(response.success && response.data){
          this.associations = response.data;
        }
      },
      error: (err) => {
        console.error('Error a obtener las asociaciones',err);
      } 
    })
  }

  onCheckboxChange(e: any, control: string, obj: any) {
    const selectedItems: FormArray = this.form.get(control) as FormArray;

    if (e.target.checked) {
      // Agregar el objeto al FormArray
      selectedItems.push(this.fb.group(obj));
    } else {
      // Buscar el índice del objeto en el FormArray
      const index = selectedItems.controls.findIndex(x => x.value.id === obj.id);

      if (index !== -1) {
        selectedItems.removeAt(index);
      }
    }
  }


  toggleSelection(option: 'professional' | 'association' | 'locked' | 'link') {
  
    // Aplicamos la selección según la opción elegida
    if (option === 'professional') {
      if(this.form.get('professional')?.value && !this.association){
        this.form.patchValue({ professional: false,type:'open'});
      } else {
        this.association = false;
        this.form.patchValue({ professional: true ,association_id:null,type:'open'});
      }
    } else if (option === 'association') {
      if(this.association){
        this.association = false;
        this.form.patchValue({ professional: false ,association_id:null,type:'open'}); 
      } else {
        this.association = true;
        this.form.patchValue({ professional: true ,type:'open'}); 
      }
    } else if (option === 'locked') {
      this.association = false;
      this.form.patchValue({ professional: false });
      this.form.patchValue({ association_id: null });

      if(this.form.get('type')?.value === 'locked' ){
        this.form.patchValue({ type: 'open' });
      } else {
        this.form.patchValue({ type: option });
      }
    } else if (option === 'link'){
      this.association = false;
      this.form.patchValue({ professional: false });
      this.form.patchValue({ association_id: null });

      if(this.form.get('type')?.value === 'link'){
        this.form.patchValue({ type: 'open' });
      } else {
        this.form.patchValue({ type: option });
      }
    }
  }
  

  removeQuadrant(pos: number){
   this.toCreateQuadrants.splice(pos,1);
    this.stationFormService.setStep2({
      quadrants: this.toCreateQuadrants
    })
  }

  isAnyQuadrantEmpty(){
    return this.toCreateQuadrants.some(q=>q.services.length<1 || q.vehicles.length<1 || q.fuels.length<1)
  }

  allCombustibles() {
    const selectedItems: FormArray = this.form.get('fuels') as FormArray;
    selectedItems.clear();

    const fuelsCheckControl: FormControl = this.form.get('fuels_check') as FormControl;
    fuelsCheckControl.setValue(true);
    this.fuels.forEach(fuel => {
      this.onCheckboxChange({target: {value: fuel.id, checked: true}}, 'fuels', fuel);
    })
  }

  allVehicles() {
    const selectedItems: FormArray = this.form.get('vehicles') as FormArray;
    selectedItems.clear();

    const fuelsCheckControl: FormControl = this.form.get('vehicles_check') as FormControl;
    fuelsCheckControl.setValue(true);
    this.vehicles.forEach(vehicle => {
      this.onCheckboxChange({target: {value: vehicle.id, checked: true}}, 'vehicles', vehicle);
    })
  }

  allServices() {
    const selectedItems: FormArray = this.form.get('services') as FormArray;
    selectedItems.clear();

    const fuelsCheckControl: FormControl = this.form.get('services_check') as FormControl;
    fuelsCheckControl.setValue(true);
    this.services.forEach(service => {
      this.onCheckboxChange({target: {value: service.id, checked: true}}, 'services', service);
    })
  }

  isServiceInArray(service: Service, services:Service[]): boolean {
    // Busca si el fuel existe en el arreglo de fuels del quadrant
    return services.some(s => s.id === service.id);
  }

  addService(quadrantPos:any,service: Service) {
    // Verifica si el servicio ya está en el array servicesToAdd
    const index = this.toCreateQuadrants[quadrantPos].services.findIndex(s => s.id === service.id);

    if (index !== -1) {
      // Si el servicio ya está, lo elimina del array
      if(this.toCreateQuadrants[quadrantPos].services.length>1){
        this.toCreateQuadrants[quadrantPos].services.splice(index,1);
        this.stationFormService.setStep2({
          quadrants: this.toCreateQuadrants
        })
      }else{
        this.toastr.info('Debe haber como mínimo un servicio')
      }
    } else {
      this.toCreateQuadrants[quadrantPos].services.push(service);
      this.stationFormService.setStep2({
        quadrants: this.toCreateQuadrants
      })
    }
  }

  isVehicleInArray(vehicle: Vehicle, vehicles:Vehicle[]): boolean {
    // Busca si el fuel existe en el arreglo de fuels del quadrant
    return vehicles.some(v => v.id === vehicle.id);
  }
  addVehicle(quadrantPos:any,vehicle: Vehicle) {
    // Verifica si el vehicle ya está en el array vehiclesToAdd
    const index = this.toCreateQuadrants[quadrantPos].vehicles.findIndex(v => v.id === vehicle.id);

    if (index !== -1) {
      // Si el vehicle ya está, lo elimina del array
      if(this.toCreateQuadrants[quadrantPos].vehicles.length>1){
        this.toCreateQuadrants[quadrantPos].vehicles.splice(index,1);
        this.stationFormService.setStep2({
          quadrants: this.toCreateQuadrants
        })
      } else {
        this.toastr.info('Debe haber como mínimo un vehículo')
      }
    } else {
      // Si el vehicle no está, lo añade al array
      this.toCreateQuadrants[quadrantPos].vehicles.push(vehicle);
      this.stationFormService.setStep2({
        quadrants: this.toCreateQuadrants
      })
    }
  }

  isFuelInArray(fuel: Fuel, fuels:Fuel[]): boolean {
    // Busca si el fuel existe en el arreglo de fuels del quadrant
    return fuels.some(f => f.id === fuel.id);
  }

  addFuel(quadrantPos:any,fuel: Fuel) {
    // Verifica si el combustible ya está en el array
    const index = this.toCreateQuadrants[quadrantPos].fuels.findIndex(f => f.id === fuel.id);

    if (index !== -1) {
      // Si el combustible ya está, lo elimina del array
      if(this.toCreateQuadrants[quadrantPos].fuels.length>1){
        this.toCreateQuadrants[quadrantPos].fuels.splice(index,1);
        this.stationFormService.setStep2({
          quadrants: this.toCreateQuadrants
        })
      } else {
        this.toastr.info('Debe haber como mínimo un combustible')
      }
    } else {
      // Si el combustible no está, lo añade al array
      this.toCreateQuadrants[quadrantPos].fuels.push(fuel);
      this.stationFormService.setStep2({
        quadrants: this.toCreateQuadrants
      })
    }
  }

  checkQuadrantHasService(serviceId: number): boolean {
    if (!this.quadrants && !this.toCreateQuadrants) return false;
  
    let recorrerCuadrants = [...(this.quadrants || []), ...(this.toCreateQuadrants || [])];
  
    return recorrerCuadrants.some(quadrant => {
      // Verificar si el cuadrante tiene el servicio con el ID especificado
      const serviceExists = quadrant.services.some((service: Service) => service.id === serviceId);
  
      if (
        serviceExists &&
        quadrant.professional === this.form.value.professional &&
        quadrant.association_id === this.form.value.association_id
      ) {
        // Verificar si algún vehículo del formulario coincide con los vehículos del cuadrante
        const formVehicles: Vehicle[] = this.form.value.vehicles || [];
        const sameVehicles = formVehicles.every(formVehicle =>
          quadrant.vehicles.some(quadrantVehicle => {
            if ('pivot' in quadrantVehicle) {
              return quadrantVehicle.id === formVehicle.id && quadrantVehicle.pivot?.visible;
            }
            return quadrantVehicle.id === formVehicle.id;
          })
        );
  
        // ✅ Solo bloquear si TODOS los valores coinciden, incluyendo type
        return sameVehicles && quadrant.type === this.form.value.type;
      }
  
      return false; // Si no cumple las condiciones, continuar con el siguiente cuadrante
    });
  }
  

  quadrantAlreadyExists(){

    return this.form.value.services.some((service: any) => {
      return this.checkQuadrantHasService(service.id);
       // Si no hay coincidencia, continuar.
    });

  }

  generateQuadrant(){
    if (this.form.valid) {
      if(this.editStation){
        if(this.quadrants){
          // console.log(this.form.value);
          // console.log(this.quadrants[0]);
          let existingQuadrant = this.quadrants.some(q =>
            q.name === this.form.get('name')?.value);

          let alreadyExists = this.quadrantAlreadyExists();

          if(existingQuadrant){
            this.toastr.error('Ya existe ese cuadrante');
          } else if (alreadyExists) {
            this.toastr.error('Ya tienes un cuadrante con este servicio y vehículo');
          } else {
            //console.log(this.form.value);

            // console.log(this.form.value);
            this.toCreateQuadrants.push({
              ...this.form.value,
              sections: [],
              id: Math.floor(Date.now() / 1000)
            });
            this.form.reset();

            // Clear the FormArray items manually
            (this.form.get('services') as FormArray).clear();
            (this.form.get('vehicles') as FormArray).clear();
            (this.form.get('fuels') as FormArray).clear();
            this.form.patchValue({
              professional: false,
              type: '',
              association:null
            })
          }
        }
      } else {
        let alreadyExists = this.quadrantAlreadyExists();

        if (alreadyExists) {
          this.toastr.error('Ya tienes un cuadrante con este servicio y vehículo');
        } else {
          // console.log(this.form.value);
          this.toCreateQuadrants.push({
            ...this.form.value,
            sections: [],
            id: Math.floor(Date.now() / 1000)
          });
          this.form.reset();

          // Clear the FormArray items manually
          (this.form.get('services') as FormArray).clear();
          (this.form.get('vehicles') as FormArray).clear();
          (this.form.get('fuels') as FormArray).clear();
          this.form.patchValue({
            professional: false,
            type: '',
            association_id: null,
          })
        }

      }

    } else {
      this.form.markAllAsTouched();
    }
  }

  haveSameServices(services1: Service[], services2: Service[]): boolean {
    if (services1.length !== services2.length) return false;
    const sorted1 = services1.map(s => s.id).sort();
    const sorted2 = services2.map(s => s.id).sort();
    return JSON.stringify(sorted1) === JSON.stringify(sorted2);
  }
  
  haveSameVehicles(vehicles1: Vehicle[], vehicles2: Vehicle[]): boolean {
    if (vehicles1.length !== vehicles2.length) return false;
    const sorted1 = vehicles1.map(v => v.id).sort();
    const sorted2 = vehicles2.map(v => v.id).sort();
    return JSON.stringify(sorted1) === JSON.stringify(sorted2);
  }

  areQuadrantsEqual(q1: Quadrant | Step2Quadrants, q2: Step2Quadrants): boolean {
    
    return (

      q1.type === q2.type &&
      Boolean(q1.professional) === Boolean(q2.professional) &&
      q1.association_id === q2.association_id &&
      this.haveSameServices(q1.services, q2.services) &&
      this.haveSameVehicles(q1.vehicles, q2.vehicles)
    );
  }

  generateQuadrantV2() {  
    if (this.form.valid) {
      const newQuadrant: Step2Quadrants = {
        ...this.form.value,
        sections: [],
        id: Math.floor(Date.now() / 1000),
      };
  
      let duplicateInQuadrants = false;
  
      // 🔍 Verificar duplicados en quadrants
      if(this.quadrants){
        duplicateInQuadrants = this.quadrants.some(q => {
          const isEqual = this.areQuadrantsEqual(q, newQuadrant);
          return isEqual;
        });
      }
  
      // 🔍 Verificar duplicados en toCreateQuadrants
      let duplicateInToCreate = this.toCreateQuadrants.some(q => {
        const isEqual = this.areQuadrantsEqual(q, newQuadrant);
        return isEqual;
      });
  
      // 🛑 Si ya existe en quadrants, bloquear
      if (duplicateInQuadrants) {
        this.toastr.error("Ya tienes un cuadrante con los mismos servicios, vehículos, tipo, profesional y asociación");
        return;
      }
  
      // 🛑 Si ya existe en toCreateQuadrants, bloquear
      if (duplicateInToCreate) {
        this.toastr.error("Este cuadrante ya ha sido agregado en la lista de creación");
        return;
      }
  
      // ✅ Agregar el nuevo cuadrante
      this.toCreateQuadrants.push(newQuadrant);  
      // Limpiar el formulario
      this.association = false;
      this.form.reset();
      (this.form.get('services') as FormArray).clear();
      (this.form.get('vehicles') as FormArray).clear();
      (this.form.get('fuels') as FormArray).clear();
      this.form.patchValue({
        link: '',
        professional: false,
        type: 'open',
        association_id: null,
      });
    } else {
      this.form.markAllAsTouched();
    }
  }
  

  next(){
    if (this.editStation) {
      this.onAddQuadrants.emit(this.toCreateQuadrants);
      this.toCreateQuadrants = [];
      this.form.reset();

      // Clear the FormArray items manually
      (this.form.get('services') as FormArray).clear();
      (this.form.get('vehicles') as FormArray).clear();
      (this.form.get('fuels') as FormArray).clear();
      this.form.patchValue({
        professional: false,
        link: '',
        association_id: null,
      })
    } else {
      this.stationFormService.setStep2({
        quadrants: this.toCreateQuadrants
      })
      this.stationFormService.changeToStep(3);
    }

  }
}
